import React, { useEffect } from 'react';
import {useData} from '../context/DataContext';
import {useLang} from '../context/LanguageContext';
import CustomSlider from '../components/CustomSlider';
import LastPredictionsSlider from '../components/LastPredictionsSlider';
import CheckSoccerPredictions from '../components/CheckSoccerPredictions';
import Generation from '../components/Generation';
import LanguageCard from '../components/LanguageCard';
import Card from '../components/mainCards/Card';
import CardActiveUsers from '../components/mainCards/CardActiveUsers';
import CardMyAccount from '../components/mainCards/CardMyAccount';
import CardHowToUse from '../components/mainCards/CardHowToUse';
import CardWapp from '../components/mainCards/CardWapp';
import AddToHomeCard from '../components/mainCards/AddToHomeCard';
import Lottie from 'lottie-react';
import loadingAnimation from '../lotties/loading_ball.json';
import winningsAnimation from '../lotties/lottie_trophy3.json';
import predictionsAnimation from '../lotties/lottie_statistics.json';
import percentageAnimation from '../lotties/lottie_percentage2.json';
import wappLottie from '../lotties/wapp_lottie.json';
import FacebookCard from "../components/mainCards/FacebookCard";
// import ContestCard from "../components/mainCards/ContestCard";
import VipCard from "../components/mainCards/VipCard";
import Footer from "../components/Footer";

const HomePage = () => {
  const { t, language } = useLang();
  const {stats, lastPredictions, loaded, errorStats} = useData();

  useEffect(() => {
    // Scroll to the top when component mounts
    window.scrollTo(0, 0);
  }, []);

  if (!loaded) {
    return (
      <div className="bg-gray-100 min-h-screen flex flex-col items-center justify-center">
        {/*<h2>Se incarca aplicatia</h2>*/}
        <Lottie animationData={loadingAnimation} style={{ width: 150, height: 150 }} />
      </div>
    );
  }

  if (errorStats) {
    return (
      <div className="bg-gray-100 min-h-screen flex items-center justify-center text-red-500">
        {errorStats}
      </div>
    );
  }

  // ----- Missing Stats (but not loading) -----
  if (!stats) {
    return (
      <div className="bg-gray-100 min-h-screen flex items-center justify-center">
        Error
      </div>
    );
  }

  // ----- Main Render -----
  return (
    <div
      className="relative bg-[#34495e] min-h-screen flex flex-col items-center bg-cover bg-no-repeat bg-center bg-fixed"
      style={{ backgroundImage: "url('/assets/images/laponturi-bg2.webp')" }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[#34495e] opacity-50 z-1" />

      <div className="relative z-20">
        {/* Main Slider */}
        <CustomSlider />

        {/* My Account Card */}
        <CardMyAccount/>

        {/* Active Users */}
        <CardActiveUsers
          title={t('txt.activeUsers')}
          value={stats.abonati}
        />

        {/* Total Winnings Predictions */}
        <Card
          title={t('txt.totalWinnings')}
          value={stats.win}
          animationData={winningsAnimation}
        />

        {/* Total Predictions */}
        <Card
          title={t('txt.totalPredictions')}
          value={stats.total}
          animationData={predictionsAnimation}
        />

        {/* Winning Predictions Percentage */}
        <Card
          title={t('txt.winningPercentage')}
          value={stats.percentage}
          suffix="%"
          animationData={percentageAnimation}
        />

        {/* How to Use the App */}
        <CardHowToUse 
        title={t('txt.howtouseApp')}/>

        {/*<ContestCard/>*/}
        {language !== 'es' &&
          <VipCard />
        }

        {/* Last Predictions Slider */}
        {lastPredictions && (
          <LastPredictionsSlider data={lastPredictions} />
        )}

        {/* Check Soccer Predictions */}
        <CheckSoccerPredictions />

        {/* Generation */}
        <Generation />

        <FacebookCard/>

        {/* Language Selector */}
        <LanguageCard />

        {language !== 'es' &&
          <CardWapp
            title={t('txt.contactWhatsapp')}
            value="+40760873168"
            animationData={wappLottie}
          />
        }
        <AddToHomeCard
        title={t('txt.homeShortcut')}
      />
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
